{
  "page_count": "de {n, plural, one{# página} other{# páginas}}"
}
